import React, { Component } from 'react';
import Auth from 'j-toker';
import styled from 'styled-components';
import Select from 'components/ui/SelectField';
import StatusTag from 'components/ui/StatusTag';
import DebouncedSearch from 'components/ui/DebouncedSearch';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import { objectToQuery } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import { apiGet } from 'helpers/ApiHelper';

const FullWidthDebouncedSearch = styled(DebouncedSearch)`
  width: 100%;
`;

const ColCutoff = styled(Col)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

class MaintenanceTicketSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResult: [],
      searchLoading: false,
      searchValue: undefined,
    };
  }

  componentDidMount() {
    if (this.props.propertyIds) {
      this.handleSearch();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.propertyIds && this.props.propertyIds !== prevProps.propertyIds) {
      this.handleSearch();
    }
  }

  handleSearch = (query = null) => {
    let searchParams = {
      property_ids: this.props.propertyIds,
    };
    if (query) {
      searchParams['query'] = query;
    }

    apiGet(`${Auth.getApiUrl()}/landlords/search_maintenance_tickets${objectToQuery(searchParams)}`)
      .done(response => {
        this.setState({
          searchResult: response.search_result && response.search_result.data,
          searchLoading: false,
        });
      })
      .catch(error => {
        this.setState({ searchLoading: false });
      });
  };

  handleSelect = value => {
    let selectedTicket = this.state.searchResult.find(ticket => ticket.id === value);

    this.props.handleSelectItem(selectedTicket);
    this.handleSearch();
  };

  render() {
    // We don't want to show the selected service requests in the search results
    // And formik is transforming these values to strings
    const selectedServiceRequests = (this.props.selectedServiceRequests || []).map(serviceRequest =>
      parseInt(serviceRequest)
    );
    const serviceRequestsToLink = this.state.searchResult.filter(
      record => !selectedServiceRequests.includes(parseInt(record.id))
    );

    return (
      <FullWidthDebouncedSearch
        showSearch
        placeholder={getTranslatedString('landlordPortal.maintenanceTicketSearch.searchSelect')}
        size="large"
        onSearch={this.handleSearch}
        beforeSearch={query => this.setState({ searchLoading: true })}
        onSelect={this.handleSelect}
        filterOption={false}
        notFoundContent={null}
        showArrow={false}
        disabled={!this.props.propertyIds}
        loading={this.state.searchLoading}
        value={this.state.searchValue}
      >
        {this._renderSelectOptions(serviceRequestsToLink)}
      </FullWidthDebouncedSearch>
    );
  }

  _renderSelectOptions = serviceRequestsToLink => {
    if (!serviceRequestsToLink || serviceRequestsToLink.length === 0)
      return (
        <Select.Option key="1" value="none">
          {getTranslatedString('landlordPortal.maintenance.tickets.noneFound')}
        </Select.Option>
      );

    return serviceRequestsToLink.map(record => {
      let ticketNumber = getTranslatedString(
        'landlordPortal.maintenanceTicketSearch.selectOptionLabel',
        { ticketNumber: record.attributes.ticket_number }
      );
      if (record.attributes.unit_number) {
        ticketNumber = getTranslatedString(
          'landlordPortal.maintenanceTicketSearch.selectOptionLabelWithUnit',
          {
            ticketNumber: record.attributes.ticket_number,
            unitNumber: record.attributes.unit_number,
          }
        );
      }
      const statusLabel = <StatusTag status={record.attributes.status} />;
      return (
        <Select.Option value={record.id} key={`searched_service_request_${record.id}`}>
          <Row gutter={16}>
            <Col xs={18}>{ticketNumber}</Col>
            <Col xs={6}>
              <span style={{ float: 'right' }}>{statusLabel}</span>
            </Col>
            <ColCutoff xs={18}>
              <small>{record.attributes.subject}</small>
            </ColCutoff>
          </Row>
        </Select.Option>
      );
    });
  };
}

export default MaintenanceTicketSearch;
